import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-model',
  templateUrl: './warning-model.component.html',
  styleUrls: ['./warning-model.component.scss']
})
export class WarningModelComponent implements OnInit {
  dialogText: string
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<WarningModelComponent>,

  ) {
    this.dialogText = this.data.dialogText;
   }

  ngOnInit(): void {
  }


  deleteAndClose(): void {
    this.dialogRef.close('yes');
  }

  closeDialog(): void {
    this.dialogRef.close('no');
  }

}
